import React from 'react';

import { sendEventClick } from 'src/api/tracker';

import Tile from 'src/components/Tile/Tile';
import TileActionsToggle from 'src/components/Tile/TileActionsToggle';
import SeeAllTile from 'src/components/SeeAllTile';
import EmptyListing from 'src/components/EmptyListing';

import { useSuperOffersContainer, sendAnalyticsEvent } from './utils';

const SuperOffersContainer = () => {
  const { superOffers, links, toggleFavouriteOffer } =
    useSuperOffersContainer();

  if (superOffers.length === 0) {
    return (
      <EmptyListing
        copy=""
        header="Zobacz wszystkie oferty"
        link={links.LINK_SUPER_OFFERS}
      />
    );
  }

  return (
    <>
      {superOffers.map((superOffer, index) => (
        <Tile
          key={superOffer.offerId}
          callback={(event) => {
            sendEventClick('dailyspecials_super', index);
            sendAnalyticsEvent(event, { ...superOffer, position: index });
          }}
          offer={superOffer}
        >
          <TileActionsToggle
            isFavourite={superOffer.isFavourite}
            toggleFavourite={() =>
              toggleFavouriteOffer(superOffer.offerId, superOffer.isFavourite)
            }
          />
        </Tile>
      ))}

      <SeeAllTile
        link={links.LINK_SUPER_OFFERS}
        title="Zobacz wszystkie oferty"
      >
        {' '}
        Zobacz wszystkie
        <br /> oferty
      </SeeAllTile>
    </>
  );
};

export default SuperOffersContainer;
